import React from "react";

const LimitSetHeader = ({ limitSetInfo, setLimitSetInfo, setHasChanges }) => {
  const handleOptionChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name !== "LimitSetName") {
      value = parseInt(e.target.value);
      if (isNaN(value)) {
        value = 0;
      }
    }

    setLimitSetInfo({ ...limitSetInfo, [e.target.name]: value });
    setHasChanges(true);
  };

  return (
    <div>
      <div className="row ml-1">
        <div className="col-sm-9">
          <div className="row">
            <div className="col-sm-4" style={{ textAlign: "center" }}>
              <label style={{ color: "#8c8c8c", fontSize: "15px" }}>
                LimitSet Name
              </label>
            </div>
            <div className="col-sm-4">
              <label style={{ color: "#8c8c8c", fontSize: "15px" }}>
                Max # of selections per parlay
              </label>
            </div>
            <div className="col-sm-4">
              <label style={{ color: "#8c8c8c", fontSize: "15px" }}>
                Max payout per: player/race
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <input
                className="form-control ml-1"
                value={limitSetInfo.LimitSetName}
                name="LimitSetName"
                style={{
                  display: "initial",
                  textAlign: "center",
                }}
                onChange={handleOptionChange}
              ></input>
            </div>
            <div className="col-sm-4" style={{ textAlign: "center" }}>
              <input
                className="form-control"
                style={{
                  width: "100px",
                  display: "initial",
                  textAlign: "center",
                }}
                name="ParlayMaxSize"
                value={limitSetInfo.ParlayMaxSize}
                onChange={handleOptionChange}
              ></input>
            </div>
            <div className="col-sm-4" style={{ textAlign: "center" }}>
              <input
                className="form-control"
                style={{
                  width: "100px",
                  display: "initial",
                  textAlign: "center",
                }}
                name="MaxRaceWin"
                value={limitSetInfo.MaxRaceWin}
                onChange={handleOptionChange}
              ></input>
            </div>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="form-group">
            <div className="form-check mt-2">
              <input
                className="form-check-input"
                type="radio"
                name="MaxRaceWinType"
                id="MaxRaceWinType1"
                value="0"
                checked={limitSetInfo.MaxRaceWinType === 0 ? true : false}
                onChange={handleOptionChange}
              />
              <label
                className="form-check-label"
                htmlFor="MaxRaceWinType1"
                style={{ color: "#8c8c8c", fontSize: "16px" }}
              >
                Maximum gross payout
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="MaxRaceWinType"
                id="MaxRaceWinType2"
                value="1"
                checked={limitSetInfo.MaxRaceWinType === 1 ? true : false}
                onChange={handleOptionChange}
              />
              <label
                className="form-check-label"
                htmlFor="MaxRaceWinType2"
                style={{ color: "#8c8c8c", fontSize: "16px" }}
              >
                Maximum net profit
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitSetHeader;
